import axios from "axios";
const API_BASE_URL = "https://fishbot-backend.herokuapp.com/";

export const playerXpGainedApi = (username) => axios.create({
  baseURL: API_BASE_URL + "api/xpgained/"+username.toLowerCase(),
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});
